import * as React from 'react';
import Radio from 'antd/lib/radio';
import withStyles from 'react-jss';
const styles = theme => ({
  radioButton: {},
});

const RadioGroup = (props) => {
  const {
    options,
    onChange,
    value,
    style,
    disabled,
    classes,
  } = props;

  return <Radio.Group
    onChange={e => onChange(e.target.value)}
    value={value}
    style={style}
    disabled={disabled}
  >
    {options?.map(option => <Radio
      key={options.key}
      className={classes.radio}
      value={option.key}>
        {option.label}
      </Radio>) || []}
    </Radio.Group>;
};

export default React.memo(withStyles(styles)(RadioGroup));